import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Box } from '@mui/material';
import styles from '../../styles/components/video-button-group.module.scss';
import ManageMessageIcon from '../../public/assets/icons/ManageMessageIcon';
import CustomSelect from '../CustomSelect/CustomSelect';

// const StatusProps{
//     getStatusSearchData:any;
//     empty:any;
// }

const VideoButtonGroup = (props) => {
    const {empty} = props

    const [status, setStatus] = React.useState("");

    const searchChange = (event) => {
        setStatus(event.target.value);
    };

    /****************************/

    const [status1, setStatus1] = React.useState("");

    const searchChange1 = (event) => {
        setStatus1(event.target.value);
    };

    /****************************/

    const [status2, setStatus2] = React.useState("");

    const searchChange2 = (event) => {
        setStatus2(event.target.value);
    };

    return (
        <Box className={styles.buttonGroup}>
            <Box className={styles.buttonManage}>
                <CustomSelect
                    value={status}
                    onChange={searchChange}
                    // onClick={() => empty()}
                    displayEmpty
                >
                    <MenuItem value=""><ManageMessageIcon/> Message Admin</MenuItem>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </CustomSelect>
            </Box>

            <Box className={styles.buttonManage}>
                <CustomSelect
                    value={status1}
                    onChange={searchChange1}
                    // onClick={() => empty()}
                    displayEmpty
                >
                    <MenuItem value=""><ManageMessageIcon/> Message QC Agent</MenuItem>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </CustomSelect>
            </Box>

            <Box className={styles.buttonManage}>
                <CustomSelect
                    value={status2}
                    onChange={searchChange2}
                    // onClick={() => empty()}
                    displayEmpty
                >
                    <MenuItem value=""><ManageMessageIcon/> Message Editor</MenuItem>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </CustomSelect>
            </Box>
        </Box>
    )
}

export default VideoButtonGroup